import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';

import { Modal } from 'react-bootstrap'
import CustomSelect from 'components/CustomSelect'

import { GET, httpOk, POST } from 'helpers/api'

import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';
import { ReactComponent as TileIcon } from 'assets/icons/tile.svg';
import { ReactComponent as LooseIcon } from 'assets/icons/loose.svg';
import { useSelector } from 'react-redux';

const initData = {
	"product_id": '',
	"type": "tile",
	"version": "",
	"created_by_id": '',
	"calc_basis": "kg",
	"rows_per_box": '',
	"pieces_per_row": '',
	"ingredients": [
		{
			"raw_material_id": '',
			"quantity": ""
		},
	],
	"semi_finished_components": [
		{
			"product_id": '',
			"percentage": ""
		},
	],
};

function CreateRecipe({ modal, setModal, getData, id }) {
	const { t } = useTranslation();

	const reduxAccount = useSelector(state => state.account)

	const [sendData, setSendData] = useState(structuredClone(initData));

	const [products, setProducts] = useState([])
	const [rawMaterials, setRawMaterials] = useState([])
	const [semiFinishedProducts, setSemiFinishedProducts] = useState([])

	async function create() {
		var sendDataCopy = { ...sendData }
		if (id) {
			const response = await POST(`/recipes/${id}/versions/`, sendDataCopy)
			if (httpOk(response)) {
				setModal(false);
				setSendData(structuredClone(initData));
				getData();
			}

		} else {
			sendDataCopy.created_by_id = reduxAccount.id;
			const response = await POST('/recipes/', sendDataCopy)
			if (httpOk(response)) {
				setModal(false);
				setSendData(structuredClone(initData));
				getData();
			}
		}

	}

	function handleChange(e) {
		var sendDataCopy = { ...sendData };
		sendDataCopy[e.target.name] = e.target.value;
		setSendData(sendDataCopy);
	}

	function selectItem(option, index) {
		var sendDataCopy = { ...sendData };
		sendDataCopy.ingredients[index].raw_material_id = option?.id;
		setSendData(sendDataCopy);
	}

	function handleChangeItem(e, index) {
		var sendDataCopy = { ...sendData };
		sendDataCopy.ingredients[index][e.target.name] = e.target.value.replace(',', '.');
		setSendData(sendDataCopy);
	}

	function deleteItem(index) {
		var sendDataCopy = { ...sendData };
		sendDataCopy.ingredients.splice(index, 1)
		setSendData(sendDataCopy);
	}

	function addToList() {
		var sendDataCopy = { ...sendData };
		sendDataCopy.ingredients.push({
			raw_material_id: '',
			quantity: '',
		})
		setSendData(sendDataCopy);
	}

	function selectSemiFinshiedItem(option, index) {
		var sendDataCopy = { ...sendData };
		sendDataCopy.semi_finished_components[index].product_id = option?.id;
		setSendData(sendDataCopy);
	}

	function handleChangeSemiFinshiedItem(e, index) {
		var sendDataCopy = { ...sendData };
		sendDataCopy.semi_finished_components[index][e.target.name] = e.target.value;
		setSendData(sendDataCopy);
	}

	function deleteSemiFinshiedItem(index) {
		var sendDataCopy = { ...sendData };
		sendDataCopy.semi_finished_components.splice(index, 1)
		setSendData(sendDataCopy);
	}

	function addSemiFinshiedToList() {
		var sendDataCopy = { ...sendData };
		sendDataCopy.semi_finished_components.push({
			raw_material_id: '',
			quantity: '',
		})
		setSendData(sendDataCopy);
	}


	useEffect(() => {
		async function getRecipe() {
			const response = await GET(`/recipes/${id}/`, {})
			if (httpOk(response)) {
				setSendData(response.data)
			}
		}

		if (id) {
			getRecipe()
		}
	}, [id]);


	useEffect(() => {
		async function getProducts() {
			const response = await GET('/catalogs/products/', { size: 1000, without_recipe: true })
			if (httpOk(response)) {
				setProducts(response.data)
			}
		}

		async function getSemiFinishedProducts() {
			const response = await GET('/catalogs/products/', { size: 1000, product_type: 'semi_finished' })
			if (httpOk(response)) {
				setSemiFinishedProducts(response.data)
			}
		}

		async function getRawMaterials() {
			const response = await GET('/catalogs/raw-materials/', { size: 1000 })
			if (httpOk(response)) {
				setRawMaterials(response.data)
			}
		}


		getProducts()
		getSemiFinishedProducts()
		getRawMaterials()
	}, []);

	return (
		<>
			<Modal show={modal} centered onHide={() => setModal(false)}>
				<i className="uil-times" onClick={() => setModal(false)}></i>
				<div className="modal-title mb-12">
					{t('create_recipe')}
				</div>
				<div className="modal-subtitle mb-32">
					{t('specify_candy_type_desc')}
				</div>

				<div className="d-flex flex-column gap-16 mb-32">
					<div className="grid2 gap-16">
						<div className="form-group">
							<label>{t('sku')}</label>
							<input type="text" placeholder={t('sku')} name="sku"
								value={sendData.sku} onChange={(e) => handleChange(e)} />
						</div>


						<div className="form-group">
							<label>{t('version')}</label>
							<input type="text" placeholder={t('version')} name="version"
								value={sendData.version} onChange={(e) => handleChange(e)} />
						</div>
					</div>

					<div className="form-group">
						<label>{t('product')}</label>
						<CustomSelect
							options={products}
							value={products?.find(option => option.id === sendData?.product_id) || ''}
							getOptionLabel={(option) => `${option.code} - ${option.name}`}
							onChange={(option) => setSendData({
								...sendData,
								product_id: option.id,
								product_type: option.product_type,
								ingredients: initData.ingredients,
								semi_finished_components: option.product_type === 'finished' ? initData.semi_finished_components : [],
							})}
							placeholder={t('select_product')}
						/>
					</div>

					<div className="card technologist">
						<div className="fw-500">
							{t('type')}
						</div>

						<div className="d-flex gap-12 w-100">
							<div className={`technologist-tab ${sendData.type === 'tile' ? 'active' : ''}`} onClick={() => setSendData({ ...sendData, type: 'tile' })}>
								<TileIcon />

								<div className="technologist-tab-title">
									{t('bar_chocolate')}
								</div>

								<div className="technologist-tab-subtitle">
									{t('calculation_by_rows')}
								</div>
							</div>

							<div className={`technologist-tab ${sendData.type === 'loose' ? 'active' : ''}`} onClick={() => setSendData({ ...sendData, type: 'loose' })}>
								<LooseIcon />

								<div className="technologist-tab-title">
									{t('weight_based')}
								</div>

								<div className="technologist-tab-subtitle">
									{t('approximate_quantity')}
								</div>
							</div>
						</div>
					</div>

					<div className="card forth">
						<div className="d-between mb-16">
							<div>
								{t('raw_materials_per_kg')}
							</div>
							<button className="white small" onClick={() => addToList()}>
								<PlusIcon />
								{t('add_raw_material')}
							</button>
						</div>

						<div className="d-flex flex-column gap-12">
							{sendData?.ingredients?.map((item, index) => (
								<div className="d-flex gap-8" key={index}>
									<div style={{ minWidth: '250px', }}>
										<CustomSelect
											options={rawMaterials}
											value={rawMaterials?.find(option => option.id === item?.raw_material_id) || ''}
											getOptionLabel={(option) => `${option.code} - ${option.name}`}
											onChange={(option) => selectItem(option, index)}
											placeholder={t('sku')}
										/>

									</div>

									<input type="text" placeholder={t('quantity')} name="quantity" className="w-100"
										value={item.quantity} onChange={(e) => handleChangeItem(e, index)} />

									<button className="transparent small" style={{ height: '36px' }} onClick={() => deleteItem(index)}>
										<DeleteIcon />
									</button>
								</div>
							))}
						</div>
					</div>


					{sendData.product_type === 'finished' &&
						<div className="card forth">
							<div className="d-between mb-16">
								<div>
									{t('ingredients_per_1kg')}
								</div>
								<button className="white small" onClick={() => addSemiFinshiedToList()}>
									<PlusIcon />
									{t('add_ingredient')}
								</button>
							</div>

							<div className="d-flex flex-column gap-12">
								{sendData?.semi_finished_components?.map((item, index) => (
									<div className="d-flex gap-8" key={index}>
										<div style={{ minWidth: '250px', }}>
											<CustomSelect
												options={semiFinishedProducts}
												value={semiFinishedProducts?.find(option => option.id === item?.product_id) || ''}
												getOptionLabel={(option) => `${option.code} - ${option.name}`}
												onChange={(option) => selectSemiFinshiedItem(option, index)}
												placeholder={t('product')}
											/>
										</div>

										<input type="text" placeholder={t('percentage')} name="percentage" className="w-100"
											value={item.percentage} onChange={(e) => handleChangeSemiFinshiedItem(e, index)} />

										<button className="transparent small" style={{ height: '36px' }} onClick={() => deleteSemiFinshiedItem(index)}>
											<DeleteIcon />
										</button>
									</div>
								))}
							</div>
						</div>
					}

					<div className="alert alert-info third">
						{t('recipe_version_hint')}
					</div>
				</div>

				<div className="modal-footer">
					<button className="white" onClick={() => setModal(false)}>
						{t('cancel')}
					</button>
					<button className="dark" onClick={() => create()}>
						{t('save_recipe')}
					</button>
				</div>
			</Modal>
		</>
	)
}

export default CreateRecipe